var map = {
	"./AI.jpg": 2281,
	"./AI.webp": 4171,
	"./cloud.jpg": 4084,
	"./cloud.webp": 7982,
	"./engineering.jpg": 9190,
	"./engineering.webp": 7828,
	"./hero.svg": 6267,
	"./hero_webp.webp": 4376,
	"./hero_webp2.webp": 6450,
	"./landng pages/last.jpg": 4754,
	"./landng pages/project2.jpg": 861,
	"./landng pages/project3.jpg": 2768,
	"./landng pages/project4.jpg": 2931,
	"./landng pages/team.jpg": 5145,
	"./logo_bar2.webp": 7046,
	"./newSection.jpg": 5268,
	"./newSection.webp": 180,
	"./partnership.jpg": 3699,
	"./partnership.webp": 4503,
	"./projects/architecture.jpg": 4951,
	"./projects/architecture2.jpg": 5701,
	"./projects/ashfordpremieretaxi_vid.mp4": 7821,
	"./projects/ashfordpremiertaxi_img.webp": 2691,
	"./projects/construction2.jpg": 8159,
	"./projects/daycare.jpg": 9653,
	"./projects/dummy_construction.mp4": 2299,
	"./projects/dummy_construction.webp": 996,
	"./projects/leatherhood_img.webp": 7567,
	"./projects/leatherhood_vid.mp4": 1390,
	"./projects/solar.jpg": 5787,
	"./projects/travel.mp4": 3351,
	"./projects/travel.webp": 4168,
	"./screens.jpg": 7848,
	"./screens.png": 4652,
	"./screens.webp": 6518,
	"./screens2.png": 8500,
	"./services/CLOUD_Solutions_and_Services.webp": 9539,
	"./services/Content_Creation .webp": 607,
	"./services/Custom App Development.webp": 4771,
	"./services/Custom Website Design.webp": 7306,
	"./services/E-Commerce Website.webp": 738,
	"./services/Influencer_Marketing.webp": 1542,
	"./services/Influencer_Marketing2.webp": 3304,
	"./services/Keywords_Research.webp": 2470,
	"./services/Mobile-Responsive Design.webp": 5037,
	"./services/Technical_Seo.webp": 5859,
	"./services/WordPress Development.webp": 2788,
	"./services/ad-creation-and-testing.webp": 3326,
	"./services/ad_creation_and_testing.webp": 4440,
	"./services/ai-ml-services.webp": 4941,
	"./services/ai_and_machine_learning.webp": 7147,
	"./services/appdev2.webp": 6386,
	"./services/campaign_setup.webp": 4122,
	"./services/customwebdesign2.webp": 1775,
	"./services/ecommerce2.webp": 1864,
	"./services/ecommerce3.webp": 9243,
	"./services/local_keywords_research.webp": 6118,
	"./services/mobileresponsivedesign2.webp": 8958,
	"./services/off_page_seo.png": 8973,
	"./services/off_page_seo.webp": 7169,
	"./services/on_page_seo.webp": 1997,
	"./services/search_engine_optimization.webp": 7431,
	"./services/socialmedia2.webp": 7879,
	"./services/wordpressdev.webp": 9860,
	"./services/wordpressdev2.webp": 726,
	"./web_lottie1": 4563,
	"./web_lottie1.json": 4563,
	"./web_lottie2": 258,
	"./web_lottie2.json": 258,
	"./zentera-logo.png": 6356,
	"./zentera_logo.png": 9242,
	"./zentera_logo.webp": 7230,
	"./zentera_logoandtext.png": 1386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4867;